module.exports = __webpack_public_path__ + "static/img/x3.c4474efd.png";